import { useCallback, useState } from "react"
import useAllWorkflows from "./sections/AllWorkflowsSection/useAllWorkflows"
import { FileExplorer } from "./WorkflowFileExplorer.types"
import useMyFileSection from "./sections/MyFilesSection/useMyFileSection"
import useScopeWorkflowsSection from "./sections/ScopeWorkflowsSection/useScopeWorkflows"
import { loginRequest } from '../../authConfig'
import { callMsGraph } from '../../graph'
import { useMsal } from "@azure/msal-react"
import { msalInstance } from "../../msalInstance";
import { MAX_WORKFLOWS_TO_LOAD } from "../../utils/constants"

const useWorkflowFileExplorer = () => {
  const [selectedExplorerOption, setSelectedExplorerOption] = useState<number>(0)
  const [showFilter, setShowFilter] = useState<boolean>(false)
  const [showSort, setShowSort] = useState<boolean>(false)
  const [limit, setLimit] = useState<number>(MAX_WORKFLOWS_TO_LOAD)
  const [skip, setSkip] = useState<number>(0)
  const [showError, setShowError] = useState<boolean>(false)
  const [error, setError] = useState<Error | undefined>(undefined)
  const [searchQuery, setSearchText] = useState<string>("")
  const [showSignOut, setShowSignOut] = useState<boolean>(false)
  const { instance, accounts } = useMsal();
  const [graphData, setGraphData] = useState(null);

  const RequestProfileData = () => {
    // Silently acquires an access token which is then attached to a request for MS Graph data
    instance
      .acquireTokenSilent({
        ...loginRequest,
        account: accounts[0],
      })
      .then((response) => {
        callMsGraph(response.accessToken).then((response) => setGraphData(response));
      });
  }

  const onError = useCallback((error: Error) => {
    if (error.message === "401") {
      setShowSignOut(true)
      return
    }
    setShowError(true)
    setError(error)
  }, [])

  const [{
    fileExplorerOption: allWorkflowsExplorerOption
  }] = useAllWorkflows({ limit: limit, skip: skip, onError: onError, searchQuery: searchQuery })

  const [{
    fileExplorerOption: myFilesExplorerOption
  }] = useMyFileSection({ limit: limit, skip: skip, isStagedWorkflows: false, onError: onError, searchQuery: searchQuery })

  const [{
    fileExplorerOption: stagedWorkflowExplorerOption
  }] = useScopeWorkflowsSection({ limit: limit, skip: skip, onError: onError, searchQuery: searchQuery })

  const explorer: FileExplorer[] = [
    allWorkflowsExplorerOption,
    myFilesExplorerOption,
    stagedWorkflowExplorerOption
  ]

  const onLogout = () => {
    msalInstance.logoutRedirect({
      postLogoutRedirectUri: "/", // or any route you want the user to return to
    });
  }

  const onExpiredTokenConfirm = () => {
    setShowSignOut(false)
    onLogout()
  }

  return [{
    explorer,
    selectedExplorerOption,
    showSort,
    showFilter,
    showError,
    error,
    search: { value: searchQuery, onChange: setSearchText },
    showSignOut,
    account: accounts[0]?.name ?? "?",
    onExpiredTokenConfirm,
    setSkip,
    onToggleSort: () => setShowSort(!showSort),
    onHideSort: () => setShowSort(false),
    onToggleFilter: () => setShowFilter(!showFilter),
    onHideFilter: () => setShowFilter(false),
    onSelectExplorerOption: setSelectedExplorerOption,
    onLoadMore: () => setLimit(l => l + 20),
    onLogout,
    onHideError: () => setShowError(false),
    onError,
    RequestProfileData,
    graphData
  }]
}

export default useWorkflowFileExplorer